import React from "react";
import Content from "./Content";
import "../styles/content.css";

const Events = () => {
  return (
    <div>
      <div className="content-container">
        <div className="medium-style-content">
          <h2>Events and workshops</h2>
          <iframe
            src="https://docs.google.com/document/d/e/2PACX-1vSzd54_HfbPjy5Lgs_OWiqMGuPnXOwPUSAHzBRb4MfkV4wqr2d9da9DSpKkzqONtbBpiEfnkjS--aZS/pub?embedded=true"
            style={{ width: "100%", height: "80vh", border: "none" }}
            title="Events"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default Events;
